import { render } from "./EditAnnouncementForm.vue?vue&type=template&id=37514e33&scoped=true"
import script from "./EditAnnouncementForm.vue?vue&type=script&lang=js"
export * from "./EditAnnouncementForm.vue?vue&type=script&lang=js"

import "./EditAnnouncementForm.vue?vue&type=style&index=0&id=37514e33&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37514e33"]])

export default __exports__